import * as angular from 'angular';

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name pkpDirectionPerPoint
     * @memberof app
     *
     * @restrict E
     * @scope
     *
     * @description
     * Works like {@link pkpDirection}, but it will display the direction label only for the one specified point
     * in a bundle case.
     *
     * @param {expression} tsoNumber Like from tso0Name and tso1Name. Can be either 0 or 1.
     * @param {boolean} bundled Whether or not the point is bundled.
     * @param {Object} networkPoint `NetworkPointDto`
     * @param {string} direction The direction which can be either <tt>"EXIT"</tt> or <tt>"ENTRY"</tt>.
     * @param {boolean} showNetworkPointName Flag to show network point name.
     *
     * @author flzemke.btc
     */
    angular
        .module('app')
        .directive('pkpDirectionPerPoint', pkpDirectionPerPoint);

    function pkpDirectionPerPoint(platformSettingsService) {
        return {
            restrict: 'E',
            scope: {
                tsoNumber: '@',
                bundled: '=',
                networkPoint: '=',
                direction: '=',
                showNetworkPointName: '=?'
            },
            template:
                require('app/_directives/pkp-direction-per-point.directive.html'),
            link: linkFn
        };

        function linkFn(scope) {
            scope.showNetworkPointName = scope.showNetworkPointName || false;
            scope.DIRECTION = platformSettingsService.DIRECTION;
        }
    }
})();
